import { zodResolver } from '@hookform/resolvers/zod';
import { avatarFileSchema, pictureSchema } from '@omecare/utils';
import { z } from 'zod';

export const editAdminProfileFormSchema = z.object({
  firstname: z.string({ message: 'form.errors.required' }).min(1, {
    message: 'form.errors.required',
  }),
  lastname: z.string({ message: 'form.errors.required' }).min(1, {
    message: 'form.errors.required',
  }),
  file: avatarFileSchema,
  picture: pictureSchema,
});

export type EditAdminProfileFormValues = z.infer<
  typeof editAdminProfileFormSchema
>;
export const editAdminProfileFormResolver = zodResolver(
  editAdminProfileFormSchema,
);
